export const isEmailValid = (email: string): boolean => {
  // Регулярное выражение для проверки email
  const EMAIL_REGEXP = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\\.,;:\s@"]+\.)+[^<>()[\]\\.,;:\s@"]{2,})$/iu

  return EMAIL_REGEXP.test(email)
}
